(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-homepage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setupMarsScrollReveal() {
      var roots = document.querySelectorAll('.mars-home');

      roots.forEach(function (root) {
        if (root.getAttribute('data-mars-scroll-ready') === 'true') {
          setupMarsProgress(root);
          setupMarsAnchorScroll(root);
          return;
        }

        var sections = root.querySelectorAll('.mars-hero, .mars-section, .mars-final');
        root.setAttribute('data-mars-scroll-ready', 'true');
        root.classList.add('mars-scroll-ready');

        sections.forEach(function (item, index) {
          var offset = '0px';

          if (index > 0) {
            offset = index % 2 === 0 ? '-38px' : '38px';
          }

          item.classList.add('mars-reveal');
          item.style.setProperty('--mars-reveal-x', offset);
          item.style.setProperty('--mars-reveal-delay', index === 0 ? '0ms' : '70ms');

          if (index === 0) {
            item.classList.add('is-visible');
          }
        });

        setupMarsProgress(root);
        setupMarsAnchorScroll(root);

        if (!('IntersectionObserver' in window)) {
          sections.forEach(function (item) {
            item.classList.add('is-visible');
          });
          return;
        }

        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, {
          threshold: 0.16,
          rootMargin: '0px 0px -8% 0px'
        });

        sections.forEach(function (item, index) {
          if (index > 0) {
            observer.observe(item);
          }
        });
      });
    }

    function setupMarsProgress(root) {
      if (root.getAttribute('data-mars-progress-ready') === 'true') {
        return;
      }

      var waiting = false;

      function updateProgress() {
        waiting = false;
        var maxScroll = Math.max(1, root.offsetHeight - window.innerHeight);
        var progress = Math.min(1, Math.max(0, -root.getBoundingClientRect().top / maxScroll));
        root.style.setProperty('--mars-scroll-progress', progress.toFixed(4));
      }

      function requestUpdate() {
        if (waiting) {
          return;
        }

        waiting = true;
        window.requestAnimationFrame(updateProgress);
      }

      root.setAttribute('data-mars-progress-ready', 'true');
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      updateProgress();
    }

    function setupMarsAnchorScroll(root) {
      if (root.getAttribute('data-mars-anchor-ready') === 'true') {
        return;
      }

      root.setAttribute('data-mars-anchor-ready', 'true');
      root.addEventListener('click', function (event) {
        var link = event.target.closest('a[href^="#"]');

        if (!link) {
          return;
        }

        var id = link.getAttribute('href').slice(1);
        var target = document.getElementById(id);

        if (!target || !root.contains(target)) {
          return;
        }

        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupMarsScrollReveal);
    } else {
      setupMarsScrollReveal();
    }

    document.addEventListener('shopify:section:load', setupMarsScrollReveal);
  })();

  } catch(e) { console.error(e); }
})();
})();
